import styled from "styled-components"
import is from "styled-is"

export const FlexJustifyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${(props) => props.wrap && "flex-wrap: wrap;"}
  ${(props) => (props.center ? "align-items: center;" : "align-items: top;")}
`

export const StandardContainer = styled.div`
  width: 100%;
  padding-left: ${(props) => props.theme.padding.hMobile};
  padding-right: ${(props) => props.theme.padding.hMobile};
  ${is("$wrappedStandard")`
    max-width: ${(props) => props.theme.containerWidths.standard};
    margin: 0 auto;
  `}
  ${is("$wrappednarrow")`
    max-width: ${(props) => props.theme.containerWidths.narrow};
    margin: 0 auto;
  `}
  @media ${(props) => props.theme.breakpoints.medium} {
    padding-left: ${(props) => props.theme.padding.hDesk};
    padding-right: ${(props) => props.theme.padding.hDesk};
  }
`
export const SectionWrapper = styled.div`
  background: ${(props) => props.$bgColor || "#fff"};
`
